module.exports = __webpack_public_path__ + "img/02.6012e7ca.png";